const FLOW_FORWARD = 'FLOW_FORWARD';
const MISSED_DEPARTURE = 'MISSED_DEPARTURE';
const UPGRADE = 'UPGRADE';
const IMPULSE_UPGRADE = 'IMPULSE_UPGRADE';
const RE_ACCOMMODATE = 'RE_ACCOMMODATE';
const EXCHANGE = 'EXCHANGE';
const CANCEL_REFUND = 'CANCEL_REFUND';
const PRINT_ATB = 'PRINT_ATB';
const PRR_REFUND = 'PRR_REFUND';
const CHECKOUT = 'CHECKOUT';
const CHECKIN = 'CHECKIN';
const CANCEL_VOUCHERS = 'CANCEL_VOUCHERS';
const UPGRADE_WITH_POINTS = 'UPGRADE_WITH_POINTS';
const GENERATE_QR_CODES = 'GENERATE_QR_CODES';
const ADD_PASSENGERS = 'ADD_PASSENGERS';
const REDEEM_COMPANION_VOUCHERS = 'REDEEM_COMPANION_VOUCHERS';
const GENERATE_TICKETS = 'GENERATE_TICKETS';
const FREE_UPGRADE = 'FREE_UPGRADE';
const TIER_BENEFIT_UPGRADE = 'TIER_BENEFIT_UPGRADE';
const BUSINESS_BENEFIT_UPGRADE = 'E4B_BENEFIT_UPGRADE';
const CLONE_EXTERNAL_TICKET = 'CLONE_EXTERNAL_TICKET';

export {
  FLOW_FORWARD,
  MISSED_DEPARTURE,
  UPGRADE,
  IMPULSE_UPGRADE,
  RE_ACCOMMODATE,
  EXCHANGE,
  CANCEL_REFUND,
  PRINT_ATB,
  PRR_REFUND,
  CHECKOUT,
  CHECKIN,
  CANCEL_VOUCHERS,
  UPGRADE_WITH_POINTS,
  GENERATE_QR_CODES,
  ADD_PASSENGERS,
  REDEEM_COMPANION_VOUCHERS,
  GENERATE_TICKETS,
  FREE_UPGRADE,
  TIER_BENEFIT_UPGRADE,
  BUSINESS_BENEFIT_UPGRADE,
  CLONE_EXTERNAL_TICKET
};
